// extracted by mini-css-extract-plugin
module.exports = {"mentions":"container-component_mentions__BJzDr"};